var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.206 22.5a4.375 4.375 0 01-8.662 0H1.25v-15c0-.69.56-1.25 1.25-1.25H20c.69 0 1.25.56 1.25 1.25V10H25l3.75 5.07v7.43h-2.544a4.375 4.375 0 01-8.662 0h-6.338zM18.75 8.75h-15v10.063A4.375 4.375 0 0110.829 20h7.092c.21-.441.492-.843.829-1.188V8.75zm2.5 7.5h5v-.356L23.74 12.5h-2.49v3.75zm.625 7.5a1.876 1.876 0 100-3.751 1.876 1.876 0 000 3.751zM8.75 21.875a1.875 1.875 0 10-3.75 0 1.875 1.875 0 003.75 0z",
    fill: "#009EE0",
    fillRule: "nonzero"
  }))));
}
export default SvgIcoTruck;